module.exports = __webpack_public_path__ + "img/product_95.bfb7a74.webp";